export const getPageUrl = (asPath: string): string => {
	if (typeof window === 'undefined') {
		return `https://www.iport.ru${asPath}`
	}

	return window.location.href
}
